export default __webpack_public_path__ + "static/media/tms monroy.f08c00fa.png";